import React from 'react';

const Spacing = ({ height, width }) => {
    return (
        <div style={{ height: height, width: width }} />
    )
}

export { Spacing };
